import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { notificationsApi } from '@/api/notifications.api';

export const notificationKeys = {
  all: ['notifications'] as const,
  subscriptions: () => [...notificationKeys.all, 'subscriptions'] as const,
  history: () => [...notificationKeys.all, 'history'] as const,
  templates: () => [...notificationKeys.all, 'templates'] as const,
};

export function usePushSubscriptions() {
  return useQuery({
    queryKey: notificationKeys.subscriptions(),
    queryFn: () => notificationsApi.listSubscriptions(),
  });
}

export function useNotificationHistory() {
  return useQuery({
    queryKey: notificationKeys.history(),
    queryFn: () => notificationsApi.listHistory(),
  });
}

export function usePopupTemplates() {
  return useQuery({
    queryKey: notificationKeys.templates(),
    queryFn: () => notificationsApi.listTemplates(),
  });
}

export function useCreateNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.history() });
      toast.success('Notificación creada');
    },
    onError: () => toast.error('Error al crear notificación'),
  });
}

export function useSendNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.sendNow,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.history() });
      toast.success('Notificación enviada');
    },
    onError: () => toast.error('Error al enviar'),
  });
}

export function useCreatePopupTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.createTemplate,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.templates() });
      toast.success('Template creado');
    },
    onError: () => toast.error('Error al crear template'),
  });
}

export function useRemovePopupTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.removeTemplate,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.templates() });
      toast.success('Template eliminado');
    },
    onError: () => toast.error('Error al eliminar'),
  });
}

export function useSendPopup() {
  return useMutation({
    mutationFn: notificationsApi.sendPopup,
    onSuccess: () => toast.success('Popup enviado'),
    onError: () => toast.error('Error al enviar popup'),
  });
}

export function useRemoveSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.removeSubscription,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.subscriptions() });
      toast.success('Suscripción eliminada');
    },
    onError: () => toast.error('Error al eliminar'),
  });
}
